const STORAGE_KEY = 'cfcu-fsb-home-popup-submitted';
const OPEN_DELAY_MS = 1000;
const RE_PROMPT_DAYS = 0;
const HUBSPOT_CONFIG = {
    region: 'na1',
    portalId: '2674865',
    formId: '58d74bc8-0e40-4178-83f7-42719058931d',
};

class HomePopup {
    constructor() {
        this.overlay = null;
        this.lastFocusedEl = null;
        this.openTimer = null;
    }

    init() {
        this.overlay = document.querySelector('.js-home-popup');
        if (!this.overlay) return;

        if (this.hasAlreadySubmitted()) return;

        this.bindCloseHandlers();
        this.mountHubspotForm();
        this.openTimer = window.setTimeout(() => this.open(), OPEN_DELAY_MS);
    }

    hasAlreadySubmitted() {
        try {
            const raw = window.localStorage.getItem(STORAGE_KEY);
            if (!raw) return false;
            if (!RE_PROMPT_DAYS) return true;

            const submittedAt = parseInt(raw, 10);
            if (Number.isNaN(submittedAt)) return true;

            const ageMs = Date.now() - submittedAt;
            const thresholdMs = RE_PROMPT_DAYS * 24 * 60 * 60 * 1000;
            return ageMs < thresholdMs;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('[home-popup] localStorage unavailable, suppression check skipped:', e);
            return false;
        }
    }

    markSubmitted() {
        try {
            window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('[home-popup] localStorage unavailable, submit will not be remembered:', e);
        }
    }

    bindCloseHandlers() {
        this.overlay.querySelectorAll('.js-home-popup-close').forEach((btn) => {
            btn.addEventListener('click', () => this.close());
        });

        this.escHandler = (e) => {
            if (e.key === 'Escape' && this.isOpen()) this.close();
        };
        document.addEventListener('keydown', this.escHandler);
    }

    mountHubspotForm() {
        if (typeof window.hbspt === 'undefined' || !window.hbspt.forms) {
            // hubspot script not ready yet — retry shortly
            window.setTimeout(() => this.mountHubspotForm(), 250);
            return;
        }

        window.hbspt.forms.create({
            ...HUBSPOT_CONFIG,
            target: '.js-home-popup-form-mount',
            onFormSubmitted: () => this.markSubmitted(),
        });
    }

    open() {
        if (this.hasAlreadySubmitted()) return;

        this.lastFocusedEl = document.activeElement;
        this.overlay.hidden = false;
        // force a paint before adding .is-open so the opacity transition runs
        window.requestAnimationFrame(() => this.overlay.classList.add('is-open'));
        document.body.classList.add('home-popup-open');

        const closeBtn = this.overlay.querySelector('.home-popup-close');
        if (closeBtn) closeBtn.focus();
    }

    close() {
        if (this.openTimer) {
            window.clearTimeout(this.openTimer);
            this.openTimer = null;
        }
        this.overlay.classList.remove('is-open');
        this.overlay.hidden = true;
        document.body.classList.remove('home-popup-open');

        if (this.lastFocusedEl && typeof this.lastFocusedEl.focus === 'function') {
            this.lastFocusedEl.focus();
        }
    }

    isOpen() {
        return !this.overlay.hidden;
    }
}

export default HomePopup;

(() => {
    const popup = new HomePopup();
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => popup.init());
    } else {
        popup.init();
    }
})();
